<div *ngIf="reportType === 'InDetail'">
  <div class="report-container" id="print-section" 
       style="font-family: Arial, sans-serif; border: 1px solid black;margin-left:10mm">

    <!-- ===== HEADER SECTION ===== -->
    <table style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black; background-color: #f8f9fa;">
      <tr>
        <td style="font-size: 18px; font-weight: bold; text-align: center; white-space: nowrap; padding: 8px;">
          हिंदुस्तान प्रकाशन संस्था 
        </td>
        <td style="font-size: 20px; font-weight: bold; text-align: center;">
          Book Payment Receipt Report
        </td>
        <td style="font-size: 18px; text-align: right; white-space: nowrap; padding: 8px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td style="padding: 8px;font-weight: bold;font-size: 18px;text-align: center;"> विवेक पुस्तक प्रकाशन</td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;">
         All In Detail
        </td>
        <td style="font-size: 16px; text-align: right; white-space: nowrap; padding: 8px;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>

    <!-- ===== MAIN TABLE ===== -->
    <div class="table-responsive" style="margin: 0;">
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; border-top: none;">
        <thead>
         <tr class="custom-header">
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:10%;">Receipt No</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:8%;">Receipt Date</th>
          <!-- <th>Entry Date</th> -->
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:20;">Book Seller Name</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:13%;">Rep. Name</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:15%;">Office Rep. Name</th>
          <!-- <th>Issue Name</th>
            <th>Issue Date</th> -->
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:10%;">Invoice No</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;width:8%;">Invoice Date</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;" class="text-end">Invoice Amount</th>
          <th style="border-right: 1px solid black;border-bottom: 1px solid black;" class="text-end">Received Amount</th>

        </tr>
        </thead>

      <tbody>
        <ng-container *ngFor="let data of this.filterData">
          <tr>
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.receipt_no }}</td>
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.receipt_date }}</td>
            <!-- <td>{{ data.billdate }}</td> -->
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.book_seller_name }}</td>
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.rep_name }}</td>
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.office_rep_name }}</td>
            <!-- <td>{{ data.DS_ISSUENAME }}</td>
              <td>{{ data.DS_ISSUEDATE }}</td> -->
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.bill_no }}</td>
            <td style="border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.billdate }}</td>
            <td class="text-end" style="text-align: end;border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.bill_amount }}</td>
            <td class="text-end" style="text-align: end;border-right: 1px solid black;border-bottom: 1px solid black;">{{ data.select_entry_amt }}</td>
          </tr>
        </ng-container>
      </tbody>
        <!-- Grand Total -->
        
         <tr class="fw-bold">
          <td colspan="7" class="text-end" style="background-color: #c8753f; font-weight: bold;border-right: 1px solid black;"> Grand Total:</td>
          <td class="text-end" style="text-align: end;" style="background-color: #c8753f; font-weight: bold;border-right: 1px solid black;">{{TotalBillAmt  }}</td>
          <td class="text-end" style="text-align: end;" style="background-color: #c8753f; font-weight: bold;border-right: 1px solid black;">{{ TotalSelectedAmt  }}</td>
        </tr>
      </table>
    </div>
  </div>

  <!-- ===== ACTION BUTTONS ===== -->
  <div class="button-container noPrint" style="margin-top: 20px; text-align: center;">
    <button mat-raised-button color="primary" (click)="exportExcel('Book_InDetail_Officewise')">📊 Export</button>
    <button mat-raised-button color="accent" (click)=" printPage()">🖨️ Print</button>
    <button mat-button mat-dialog-close>❌ Close</button>
  </div>
</div>
